export default {"src":"/_next/static/media/close-icon.98a54a16.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};